import { lazy } from "react";

const UpdateReferralPolicyPage = lazy(() => import("./update"));

export { UpdateReferralPolicyPage };
